/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './sidebar.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../../../app/pages/admin/icontact/chat/side-bar/sidebar.component';
import * as i4 from '@angular/router';
const styles_ChatSideBar:any[] = [i0.styles];
export const RenderType_ChatSideBar:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_ChatSideBar,
    data:{}});
function View_ChatSideBar_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'li',([] as any[]),
      (null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.onNav(_v.context.$implicit.url)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(1,278528,(null as any),0,i2.NgClass,
      [i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{ngClass:[0,
          'ngClass']},(null as any)),i1.ɵpod(2,{'chat-sidebar-item':0,'active':1}),
      (_l()(),i1.ɵted(3,(null as any),['\n            ','\n        ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _ck(_v,2,0,true,_co.nav.includes(_v.context.$implicit.url));
    _ck(_v,1,0,currVal_0);
  },(_ck,_v) => {
    const currVal_1:any = _v.context.$implicit.name;
    _ck(_v,3,0,currVal_1);
  });
}
export function View_ChatSideBar_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),7,'nav',[['class',
      'chat-sidebar']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),4,'ul',[['class','chat-sidebar-list']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,
          (null as any),View_ChatSideBar_1)),i1.ɵdid(5,802816,(null as any),0,i2.NgForOf,
          [i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,'ngForOf']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i3.ChatSideBar = _v.component;
    const currVal_0:any = _co.channels;
    _ck(_v,5,0,currVal_0);
  },(null as any));
}
export function View_ChatSideBar_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'chat-sidebar',
      ([] as any[]),(null as any),(null as any),(null as any),View_ChatSideBar_0,RenderType_ChatSideBar)),
      i1.ɵdid(1,49152,(null as any),0,i3.ChatSideBar,[i4.Router],(null as any),(null as any))],
      (null as any),(null as any));
}
export const ChatSideBarNgFactory:i1.ComponentFactory<i3.ChatSideBar> = i1.ɵccf('chat-sidebar',
    i3.ChatSideBar,View_ChatSideBar_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvcGFnZXMvYWRtaW4vaWNvbnRhY3QvY2hhdC9zaWRlLWJhci9zaWRlYmFyLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9xdWFuaG9hbmcvemVuaWZ5L3JlcG9zL2NsaWVudC1maW5hbC9zcmMvYXBwL3BhZ2VzL2FkbWluL2ljb250YWN0L2NoYXQvc2lkZS1iYXIvc2lkZWJhci5jb21wb25lbnQudHMiLCJuZzovLy9Vc2Vycy9xdWFuaG9hbmcvemVuaWZ5L3JlcG9zL2NsaWVudC1maW5hbC9zcmMvYXBwL3BhZ2VzL2FkbWluL2ljb250YWN0L2NoYXQvc2lkZS1iYXIvc2lkZWJhci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvcGFnZXMvYWRtaW4vaWNvbnRhY3QvY2hhdC9zaWRlLWJhci9zaWRlYmFyLmNvbXBvbmVudC50cy5DaGF0U2lkZUJhcl9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxuYXYgY2xhc3M9XCJjaGF0LXNpZGViYXJcIj5cbiAgICA8dWwgY2xhc3M9XCJjaGF0LXNpZGViYXItbGlzdFwiPlxuICAgICAgICA8bGkgKm5nRm9yPVwibGV0IGNoYW5uZWwgb2YgY2hhbm5lbHNcIiAoY2xpY2spPVwib25OYXYoY2hhbm5lbC51cmwpXCIgW25nQ2xhc3NdPVwieydjaGF0LXNpZGViYXItaXRlbSc6dHJ1ZSwgJ2FjdGl2ZSc6bmF2LmluY2x1ZGVzKGNoYW5uZWwudXJsKX1cIj5cbiAgICAgICAgICAgIHt7Y2hhbm5lbC5uYW1lfX1cbiAgICAgICAgPC9saT5cbiAgICA8L3VsPlxuPC9uYXY+XG4iLCI8Y2hhdC1zaWRlYmFyPjwvY2hhdC1zaWRlYmFyPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0VRO01BQUE7UUFBQTtRQUFBO1FBQXFDO1VBQUE7VUFBQTtRQUFBO1FBQXJDO01BQUEsdUNBQUE7TUFBQTtVQUFBLGtDQUFrRTtNQUEyRTs7SUFBM0U7SUFBbEUsV0FBa0UsU0FBbEU7O0lBQTZJO0lBQUE7Ozs7b0JBRnJKO01BQUE7TUFBMEIsOENBQ3RCO1VBQUE7VUFBQSw0Q0FBOEI7VUFBQSxpQkFDMUI7VUFBQSwwQ0FBQTtVQUFBO1VBQUEsZUFFSyw4Q0FDSjtVQUFBLHVCQUNIOztJQUpNO0lBQUosV0FBSSxTQUFKOzs7O29CQ0ZSO01BQUE7YUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/pages/admin/icontact/chat/side-bar/sidebar.component.ngfactory.ts